module.exports = __webpack_public_path__ + "img/BV_logo.5134ffde.png";